/**
 *
 * UserMenu
 *
 */

import React, { useCallback, useEffect, useState } from "react"
import { push } from "connected-react-router"
import { Collapse, Icon } from "components"
import { useDispatch, useSelector } from "react-redux"
import { Tooltip, Tabs, Row, Col, Form, Input, Button } from "antd"
import { setLogout, setStaffModal, setLoader } from "store/actions"
import { capitalize } from "utils/utils"
import { Endpoints, API } from "utils/api"
import Strings from "utils/strings"
import { auth } from "firebase/firebase"
import "./styles.scss"

import userPlaceholder from "assets/images/placeholders/user.jpg"

const { TabPane } = Tabs

function UserMenu({ sidebarIsOpen }: any) {
	const dispatch = useDispatch()
	const user = useSelector((state: any) => state.user)
	const [open, setOpen] = useState(false)
	const [name, setName] = useState(user?.name || "")
	const [email, setEmail] = useState(user?.email || "")
	const [photo, setPhoto] = useState(user?.photo || null)
	const [role, setRole] = useState(user?.role || "")

	useEffect(() => {
		setName(user?.name || "")
		setEmail(user?.email || "")
		setPhoto(user?.photo || null)
		setRole(user?.role || "")
	}, [user])

	const forceFirebaseLogout = useCallback(async () => {
		try {
			await auth.signOut()
		} catch (err) {
			console.log("Firebase sign-out error", err)
		} finally {
			dispatch(setLogout())
			dispatch(push("/login"))
		}
	}, [dispatch])

	const toggleProfile = useCallback(() => {
		if (!user) {
			return
		}

		dispatch(
			setStaffModal({
				staff: JSON.parse(JSON.stringify(user)),
				open: true,
				isMe: true,
			})
		)
	}, [dispatch, user])

	const logout = useCallback(async () => {
		dispatch(setLoader(true))

		try {
			const response = await API.post({ url: Endpoints.uriLogout() })
			if (response.ok) {
				await forceFirebaseLogout()
			}
		} catch (err) {
			console.log("API Error", err)
			await forceFirebaseLogout()
		}

		dispatch(setLoader(false))
	}, [dispatch, forceFirebaseLogout])

	const getUserMenus = useCallback(() => {
		if (sidebarIsOpen) {
			return (
				<div className="SidebarMenu">
					<div className="SidebarMenuOptions __forceWidth">
						<div onClick={toggleProfile} className="SidebarMenuOption">
							<Icon name="user2" className="m10r" />
							<span>{Strings.sidebar.profile}</span>
						</div>
						<div onClick={logout} className="SidebarMenuOption">
							<Icon name="logout" className="m10r" />
							<span>{Strings.authentication.logout}</span>
						</div>
					</div>
				</div>
			)
		}

		return (
			<div className="SidebarMenu">
				<div className="SidebarMenuOptions __mobile">
					<Tooltip placement="right" title={Strings.sidebar.profile}>
						<div onClick={toggleProfile} className="SidebarMenuOption">
							<Icon name="user2" />
						</div>
					</Tooltip>
					<Tooltip placement="right" title={Strings.authentication.logout}>
						<div onClick={logout} className="SidebarMenuOption">
							<Icon name="logout" />
						</div>
					</Tooltip>
				</div>
			</div>
		)
	}, [logout, sidebarIsOpen, toggleProfile])

	const renderProfile = useCallback(() => {
		if (!user) {
			return null
		}

		return (
			<Row gutter={[24, 24]}>
				<Col xs={24} md={8}>
					<div className="ProfilePictureContainer">
						<div className="ProfilePicture">
							<img alt={Strings.profile.profilePicture} src={photo} />
						</div>
						<span className="ProfileName">{user.name}</span>
						<div className="ProfileEmail">
							<span>{email}</span>
						</div>
					</div>
					<Button type="primary" block onClick={logout}>
						{Strings.authentication.logout}
					</Button>
				</Col>
				<Col xs={24} md={16}>
					<Form layout="vertical" name="profile">
						<Form.Item
							label={Strings.fields.name}
							name="name"
							initialValue={name}
							rules={[{ required: true, message: Strings.errors.fillField }]}
						>
							<Input
								placeholder={Strings.placeholders.name}
								onChange={(e) => setName(e.target.value)}
							/>
						</Form.Item>
						<Form.Item
							label={Strings.profile.role}
							name="email"
							initialValue={capitalize(role)}
						>
							<Input disabled placeholder={Strings.placeholders.role} />
						</Form.Item>
					</Form>
				</Col>
			</Row>
		)
	}, [email, logout, name, photo, role, user])

	const renderProfileHeader = useCallback(() => {
		return (
			<Tabs defaultActiveKey="profile" centered>
				<TabPane tab={Strings.sidebar.profile} key="profile">
					{renderProfile()}
				</TabPane>
				<TabPane tab={Strings.fields.password} key="password">
					Mudar Password
				</TabPane>
			</Tabs>
		)
	}, [renderProfile])

	if (!user) {
		return null
	}

	void renderProfileHeader

	return (
		<Collapse expandedChildren={getUserMenus()} expanded={open}>
			<div
				className={`SidebarMenuObject AdjustUserMenu${open ? " active" : ""}`}
				onClick={() => setOpen((currentOpen) => !currentOpen)}
			>
				<div className="SidebarMenu">
					<div
						className="SidebarUserLogo"
						style={{
							backgroundImage: `url(${user.picture || userPlaceholder})`,
						}}
					></div>
					<span className="SidebarNavName __normal">
						{user.name || "Username"}
					</span>
				</div>
				<em className={`caret${open ? " __opened" : ""}`} />
			</div>
		</Collapse>
	)
}

export default UserMenu
